import { styled } from "@mui/material";

type KbdShortcutProps = {
  backgroundColor?: string;
  color?: string;
  padding?: string;
  borderRadius?: string;
};

const KbdShortcut = styled("kbd")<KbdShortcutProps>(({ theme, color, backgroundColor, padding, borderRadius }) => ({
  backgroundColor: backgroundColor || theme.palette.surfaceLight30.main,
  color: color || theme.palette.text50.main,
  padding: padding || 0,
  borderRadius: borderRadius || 0,
}));
export { KbdShortcut };
